import { render, staticRenderFns } from "./RenameUploadModal.vue?vue&type=template&id=0a793bfa"
import script from "./RenameUploadModal.vue?vue&type=script&lang=js"
export * from "./RenameUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports